/**
 * Tiny pub-sub for the global Undo toast (Wave 48). Any screen that
 * performs a quickly-regrettable action (complete, skip, delete) calls
 * `offerUndo` with a label and a rollback callback; the UndoToastHost
 * mounted in the root layout renders the snackbar and runs the
 * rollback if the user taps Undo within the timeout.
 *
 * Module-level singleton on purpose: the host outlives every screen,
 * and threading a context through every task list for one toast is
 * more machinery than the feature needs.
 */

export interface UndoOffer {
  /** Toast copy, e.g. "Task marked done". Keep it short. */
  message: string;
  /** Rollback. Runs when the user taps Undo. Errors are swallowed by
   *  the host (best-effort — the row may already be gone). */
  undo: () => Promise<void> | void;
  /** Called after a successful undo — e.g. the page's refetch. */
  onUndone?: () => void;
}

type Listener = (offer: UndoOffer) => void;

let listener: Listener | null = null;

export function setUndoListener(l: Listener | null): void {
  listener = l;
}

export function offerUndo(offer: UndoOffer): void {
  listener?.(offer);
}
